import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserGroup } from '../models/user-group';

@Injectable({
  providedIn: 'root'
})
export class UserGroupDataService {

  constructor(private http: HttpClient) { }

  getAllUserGroups = () :  Observable<UserGroup[]> => {
    return this.http.get<UserGroup[]>(`${environment.api.baseUrl}/${environment.api.endpoints.user.userGroupList}?projectId=0`); // TODO remove projectId as query param
  }

}
